var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { getType } from "typesafe-actions";
import * as message from "./actions";
export var initialState = {
  errorMessage: null,
  notification: null,
  notificationDisplayedUntilAnswerChanges: false
};
export var messageReducer = function messageReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(message.setErrorMessage):
      return __assign({}, state, {
        errorMessage: action.payload
      });

    case getType(message.answerWasChanged):
      if (state.notificationDisplayedUntilAnswerChanges) {
        return __assign({}, state, {
          notification: null,
          notificationDisplayedUntilAnswerChanges: false
        });
      }

      return state;

    case getType(message.setNotification):
      return __assign({}, state, {
        notification: {
          message: action.payload.message,
          color: action.payload.color
        },
        notificationDisplayedUntilAnswerChanges: action.payload.untilAnswerChanged
      });

    case getType(message.clearErrorMessage):
      return __assign({}, state, {
        errorMessage: initialState.errorMessage
      });

    case getType(message.clearNotification):
      return __assign({}, state, {
        notification: initialState.notification
      });

    case getType(message.clear):
      return initialState;

    default:
      return state;
  }
};